module.exports = __webpack_public_path__ + "img/bold.9e60675c.svg";